module.exports = __webpack_public_path__ + "static/media/WhatsApp_Logo2.eaf791e6.svg";